import Vue from "vue";
import store from "../store";
import { _warning } from "../toast";
import { AppConfiguration } from "read-appsettings-json";


import VueRouter from "vue-router";
import Login from "../components/Login.vue";
import Dashboard from "../components/Dashboard.vue";

import Projects from "../components/Expense/Projects.vue";
import Project from "../components/Expense/Project.vue";

import ExpenseCenters from "../components/Expense/ExpenseCenters.vue";
import ExpenseCenter from "../components/Expense/ExpenseCenter.vue";
import ExpenseType from "../components/Expense/ExpenseType.vue";
import ExpenseTypes from "../components/Expense/ExpenseTypes.vue";
import Expense from "../components/Expense/Expense.vue";
import Expenses from "../components/Expense/Expenses.vue";

import Advances from "../components/Advance/Advances.vue";
import Advance from "../components/Advance/Advance.vue";

import Parameters from "../components/Admin/Parameters.vue";
import Parameter from "../components/Admin/Parameter.vue";

import Users from "../components/Admin/Users.vue";
import User from "../components/Admin/User.vue";

import Tenants from "../components/Admin/Tenants.vue";
import Tenant from "../components/Admin/Tenant.vue";
import TenantProfile from "../components/Default/TenantProfile.vue";

import Connections from "../components/Admin/Connections.vue";
import Connection from "../components/Admin/Connection.vue";

import Licenses from "../components/Admin/Licenses.vue";

import LicenseBundles from "../components/Admin/LicenseBundles.vue";
import LicenseBundle from "../components/Admin/LicenseBundle.vue";

import Notifications from "../components/Default/Notifications.vue";
import Approves from "../components/Default/Approves.vue";

import Roles from "../components/Role/Roles.vue";
import Role from "../components/Role/Role.vue";
import RoleUser from "../components/Role/RoleUser.vue";
import ErrorPage from "../components/Error.vue";

import UserProfile from "../views/UserProfile.vue"; 

import Gateways from "../components/Gateway/Gateways.vue";
import Gateway from "../components/Gateway/Gateway.vue";
import TransferConfigs from "../components/Gateway/TransferConfigs.vue";
import TransferConfig from "../components/Gateway/TransferConfig.vue";
import TransferConfigHistories from "../components/Gateway/TransferConfigHistories.vue";
import TransferDatas from "../components/Gateway/TransferDatas.vue";
import InvoiceUpload from "../components/Invoice/InvoiceUpload.vue";
import InvoiceQueue from "../components/Invoice/InvoiceQueue.vue";
import Invoices from "../components/Invoice/Invoices.vue";
import InvoiceHistoryDetail from "../components/Invoice/invoiceHistoryDetail.vue";
//Eprocess
import GibUSer from "../components/eProcess/GibUserRequest.vue";
import GetDocument from "../components/eProcess/GetDocument.vue";
import GetDocumentStatus from "../components/eProcess/GetDocumentStatus.vue";
Vue.use(VueRouter);
const routes = [

  //#region  un authorized pages
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    // beforeEnter: ifAuthenticated
  }, 

  {
    path: "/userProfile",
    name: "userProfile",
    component: UserProfile,
    // beforeEnter: ifAuthenticated
  },
   {
    path: "/login",
    name: "Login",
    component: Login,
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/notifications",
    name: "notifications",
    component: Notifications,
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/approves",
    name: "approves",
    component: Approves,
    // beforeEnter: ifAuthenticated
  }, 
  {
    path: "/tenantProfile",
    name: "tenantProfile",
    component: TenantProfile,
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/error",
    name: "error",
    component: ErrorPage,
    // beforeEnter: ifAuthenticated
  },
  //#endregion
  //#region Authorized Pages

  //#region  Gateway
  {
    path: "/gateways",
    name: "gateways",
    component: Gateways,
    meta: { authorize: ["Gateway"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/gateway/:id",
    name: "gateway",
    component: Gateway,
    meta: { authorize: ["Gateway"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/transferConfigs",
    name: "transferConfigs",
    component: TransferConfigs,
    meta: { authorize: ["Gateway"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/transferConfig/:id",
    name: "transferConfig",
    component: TransferConfig,
    meta: { authorize: ["Gateway"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/transferConfigHistories",
    name: "transferConfigHistories",
    component: TransferConfigHistories,
    meta: { authorize: ["Gateway"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/transferDatas",
    name: "transferDatas",
    component: TransferDatas,
    meta: { authorize: ["Gateway"] },
    // beforeEnter: ifAuthenticated
  },
  //#endregion
  
//#region  Expense

  {
    path: "/expenseCenters",
    name: "expenseCenters",
    component: ExpenseCenters,
    meta: { authorize: ["Expense"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/expenseCenter/:id",
    name: "expenseCenter",
    component: ExpenseCenter,
    meta: { authorize: ["Expense"] },
    // beforeEnter: ifAuthenticated
  },  {
    path: "/expenseType/:id",
    name: "expenseType",
    component: ExpenseType,
    meta: { authorize: ["Expense"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/expenseTypes",
    name: "expenseTypes",
    component: ExpenseTypes,
    meta: { authorize: ["Expense"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/expenses",
    name: "expenses",
    component: Expenses,
    meta: { authorize: ["Expense"] },

    // beforeEnter: ifAuthenticated
  },
  {
    path: "/expense/:id",
    name: "expense",
    component: Expense,
    meta: { authorize: ["Expense"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/projects",
    name: "projects",
    component: Projects,
    meta: { authorize: ["Expense"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/project/:id",
    name: "project",
    component: Project,
    meta: { authorize: ["Expense"] },
    // beforeEnter: ifAuthenticated
  },

  //#endregion 

  //#region  Advance
  {
    path: "/advances",
    name: "advances",
    component: Advances,
    meta: { authorize: ["Advance"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/advance/:id",
    name: "advance",
    component: Advance,
    meta: { authorize: ["Advance"] },
    // beforeEnter: ifAuthenticated
  },
  //#endregion

  //#region  Tenant Admin
  {
    path: "/parameters",
    name: "parameters",
    component: Parameters,
    meta: { authorize: ["Management", "Parameter"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/parameter/:id",
    name: "parameter",
    component: Parameter,
    meta: { authorize: ["Management", "Parameter"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/users",
    name: "users",
    component: Users,
    meta: { authorize: ["Management", "User"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/user/:id",
    name: "user",
    component: User,
    meta: { authorize: ["Management", "User"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/roles",
    name: "roles",
    component: Roles,
    meta: { authorize: ["Management", "Role"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/role/:id",
    name: "role",
    component: Role,
    meta: { authorize: ["Management", "Role"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/roleUser/:id",
    name: "roleUser",
    component: RoleUser,
    meta: { authorize: ["Management", "Role"] },
    // beforeEnter: ifAuthenticated
  },
  
  //#endregion

  //#region  Global Admin

  {
    path: "/tenants",
    name: "tenants",
    component: Tenants,
    meta: { authorize: ["CoreManagement"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/tenant/:id",
    name: "tenant",
    component: Tenant,
    meta: { authorize: ["CoreManagement", "Tenant"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/connections",
    name: "connections",
    component: Connections,
    meta: { authorize: ["CoreManagement", "Connection"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/connection/:id",
    name: "connection",
    component: Connection,
    meta: { authorize: ["CoreManagement", "Connection"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/licenses",
    name: "licenses",
    component: Licenses,
    meta: { authorize: ["CoreManagement", "License"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/licenseBundles",
    name: "licenseBundles",
    component: LicenseBundles,
    meta: { authorize: ["CoreManagement", "LicenseBundle"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/licenseBundle/:id",
    name: "licenseBundle",
    component: LicenseBundle,
    meta: { authorize: ["CoreManagement", "LicenseBundle"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/invoiceUpload",
    name: "InvoiceUpload",
    component: InvoiceUpload,
    meta: { authorize: ["Invoice"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/invoiceQueue",
    name: "invoiceQueue",
    component: InvoiceQueue,
    meta: { authorize: ["Invoice"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/invoices",
    name: "invoices",
    component: Invoices,
    meta: { authorize: ["Invoice"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/invoices/history/:id",
    name: "invoiceHistory",
    component: InvoiceHistoryDetail,
    meta: { authorize: ["Invoice"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/eprocess/gibUSer",
    name: "gibUser",
    component: GibUSer,
    meta: { authorize: ["Eprocess"] },
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/eprocess/getDocument",
    name: "getDocument",
    component: GetDocument,
    meta: { authorize: ["Eprocess"] },
    // beforeEnter: ifAuthenticated
  },  {
    path: "/eprocess/getDocumentStatus",
    name: "getDocumentStatus",
    component: GetDocumentStatus,
    meta: { authorize: ["Eprocess"] },
    // beforeEnter: ifAuthenticated
  },
  //#endregion
  //#endregion
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {

  const currentUser = localStorage.getItem("user-token");
  const { authorize } = to.meta;
 const user= JSON.parse(localStorage.getItem("user"));
 if(user==null&&(authorize==null||authorize.find((x) => x == "*") != null))
 {
  return next();
 }

 if (to.path != "/login"   && currentUser == null  ) {
  // not logged in so redirect to login page with the return url
  return next({ path: "/login" });
}

  var authorities =user.authorities.split(",");

  if (authorities.find((y) => y == "Admin.Admin")) {
    return next();
  }

  if (authorize) {
    var found = authorize.find(
      (x) => x == "*" || authorities.find((y) => y.startsWith(x))
    );
    if (found == null) {
      _warning("Gitmek istediğiniz sayfaya yetkiniz yoktur.", "Yetki hatası");
      if (from.name == null) return next({ path: "/error" });

      return next({ path: from.path });
    }
  }
  

  next();
});


const DEFAULT_TITLE = AppConfiguration.Setting().defaultPageTitle;
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router;
